var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestionCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.75C4.54788 1.75 1.75 4.54788 1.75 8C1.75 11.4521 4.54788 14.25 8 14.25C11.4521 14.25 14.25 11.4521 14.25 8C14.25 4.54788 11.4521 1.75 8 1.75ZM0.25 8C0.25 3.71945 3.71945 0.25 8 0.25C12.2805 0.25 15.75 3.71945 15.75 8C15.75 12.2805 12.2805 15.75 8 15.75C3.71945 15.75 0.25 12.2805 0.25 8Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9165 6.08333C5.9165 4.93245 6.84896 4 7.99984 4C9.15072 4 10.0832 4.93245 10.0832 6.08333C10.0832 7.01085 9.46986 7.49589 9.09305 7.7499L9.09213 7.75052C8.94528 7.84919 8.86191 7.9226 8.81263 7.98901C8.77586 8.03857 8.74984 8.09366 8.74984 8.19467V8.36133C8.74984 8.77555 8.41405 9.11133 7.99984 9.11133C7.58562 9.11133 7.24984 8.77555 7.24984 8.36133V8.19467C7.24984 7.25614 7.86924 6.76512 8.255 6.50585C8.39795 6.40945 8.47781 6.33873 8.52459 6.27565C8.55892 6.22936 8.58317 6.17851 8.58317 6.08333C8.58317 5.76088 8.32229 5.5 7.99984 5.5C7.67738 5.5 7.4165 5.76088 7.4165 6.08333C7.4165 6.49755 7.08072 6.83333 6.6665 6.83333C6.25229 6.83333 5.9165 6.49755 5.9165 6.08333Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C7.7 12 7.5 11.9 7.3 11.7C7.1 11.5 7 11.3 7 11C7 10.5 7.4 10 8 10C8.6 10 9 10.4 9 11C9 11.6 8.5 12 8 12Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionCircle);
export default __webpack_public_path__ + "static/media/icon-question-circle.420d79d19ecd2dfb94be1693aeb76658.svg";
export { ForwardRef as ReactComponent };